export const API = {
  apiHost: "/api",
  pageSize: 30,
};
